/* Mega-menu au SURVOL — Lauven, 2026-09-16.
 *
 * Horizon n'ouvre ses sous-menus qu'au CLIC : chaque entree porte un
 * <button aria-expanded> et le survol ne fait que surligner (`on:pointerenter`
 * appelle `/activate`, pas `/toggle`). Mesure du 16/09 : 8 boutons, 0 ouverture
 * au survol. Les boutiques de mode comparables ouvrent au survol — un clic de
 * plus par categorie sur le chemin le plus emprunte du site.
 *
 * On n'y touche QUE sur un pointeur fin (souris). Au doigt, le survol n'existe
 * pas et un menu qui s'ouvre tout seul rend la navigation imprevisible : le
 * clic reste seul maitre sur mobile et tablette.
 * On ne remplace pas le mecanisme du theme, on declenche le SIEN — l'etat,
 * l'attribut `inert` et le focus restent geres par header-menu.js.
 */
(() => {
  const fin = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!fin.matches) return;

  const DELAI_FERMETURE = 180; // ms — laisse traverser un interstice sans refermer
  let minuterie = null;

  const boutonDe = (li) => li.querySelector(':scope > .menu-list__trigger > .menu-list__disclosure');

  const ouvrir = (li) => {
    const b = boutonDe(li);
    if (b && b.getAttribute('aria-expanded') !== 'true') b.click();
  };

  const fermer = (li) => {
    const b = boutonDe(li);
    if (b && b.getAttribute('aria-expanded') === 'true') b.click();
  };

  const brancher = (racine) => {
    racine.querySelectorAll('.menu-list__list-item').forEach((li) => {
      if (li.dataset.lvSurvol === '1' || !boutonDe(li)) return;
      li.dataset.lvSurvol = '1';

      li.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(minuterie);
        racine.querySelectorAll('.menu-list__list-item').forEach((a) => { if (a !== li) fermer(a); });
        ouvrir(li);
      });

      li.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(minuterie);
        minuterie = setTimeout(() => fermer(li), DELAI_FERMETURE);
      });

      // Echap referme, comme partout ailleurs dans le theme.
      li.addEventListener('keydown', (e) => { if (e.key === 'Escape') fermer(li); });
    });
  };

  const demarrer = () => {
    document.querySelectorAll('.menu-list, [ref="menuList"]').forEach(brancher);
    if (!document.querySelector('.menu-list__list-item')) brancher(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
  // Le header est re-rendu par l'editeur et par la navigation instantanee.
  document.addEventListener('shopify:section:load', demarrer);
})();
